enum ShareableVariant {
  BasicSlideshowV1 = 'BasicSlideshowV1',
  FlashingImagesAndWheelV1 = 'FlashingImagesAndWheelV1',
  FlashingSlideshowV1 = 'FlashingSlideshowV1',
  ScrollingProfilesV1 = 'ScrollingProfilesV1',
  SpiralSlideshowV1 = 'SpiralSlideshowV1'
}
export default ShareableVariant
